import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from 'react';

import { SellerVtex } from 'pages/logistica/sellers-vetex/types';

type SellersVtexContext = {
    sellersVtex: SellerVtex[];
    setSellersVtex: Dispatch<SetStateAction<SellerVtex[]>>;
};

type SellersVtexProvider = {
    children?: ReactNode;
};

const SellersVtexContext = createContext<SellersVtexContext>({} as SellersVtexContext);

export function SellersVtexProvider({ children }: SellersVtexProvider) {
    const [sellersVtex, setSellersVtex] = useState<SellerVtex[]>([]);

    return (
        <SellersVtexContext.Provider
            value={{
                sellersVtex,
                setSellersVtex,
            }}
        >
            {children}
        </SellersVtexContext.Provider>
    );
}

export const useSellersVtexContext = (): SellersVtexContext => useContext(SellersVtexContext);
